import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API } from '../../services/axios.service';

const initialState = {
    chosenBot: {},
    topics: {},
    chosenTopic: null,
    currentBot: {
        data: {},
        status: "",
        error: ""
    },
    status: 'idle',
    error: ''
}


// Define the async thunk
// export const fetchCurrentBot = createAsyncThunk(
//     'chatbox/fetchCurrentBot',
//     async (botId, thunkAPI) => {
//         const response = await API.get(`/chatbot/details/${botId}`);
//         console.log("response", response)
//         return response.data; // Adjust based on the actual response structure
//     }
// );


// Update the async thunk
export const fetchCurrentBot = createAsyncThunk(
    'chatbox/fetchCurrentBot',
    async (botId, { getState }) => {
        const state = getState();
        // Check if bot data for the requested botId is already in the state
        if (state.chatbox.currentBot?.data[botId]) {
            return { id: botId, data: state.chatbox.currentBot.data[botId] };
        }
        const response = await API.get(`/chatbot/details/${botId}`);
        // Assuming the response data is the bot's details
        return { id: botId, data: response.data }; // Adjust based on the actual response structure
    }
);



export const chatBoxSlice = createSlice({
    name: 'chatbox',
    initialState,
    reducers: {
        resetState: (state) => {
            state.data = []
        },
        setTopics: (state, action) => {
            state.topics = action.payload;
        },
        setChosenBot: (state, action) => {
            state.chosenBot = action.payload;
        },
        setChosenTopic: (state, action) => {
            state.chosenTopic = action.payload;
        },
        updateCurrentBotInfo: (state, action) => {
            const { botId, botInfo } = action.payload;
            // Check if the bot exists in the state
            if (state.currentBot.data[botId]) {
                // Update the bot's information with the provided payload
                state.currentBot.data[botId].data = { ...state.currentBot.data[botId].data, ...botInfo };
            }
        },
        setTopicEnded: (state, action) => {
            state.topics = state.topics.map(item => {
                if (item.id === action.payload) return { ...item, "ended": true };
                return item;
            })
            if (state.chosenTopic.id === action.payload) {
                state.chosenTopic = { ...state.chosenTopic, "ended": true };
            }
        },
        setTopicFeedback: (state, action) => {
            const { topic, feedback } = action.payload;
            state.topics = state.topics.map(item => {
                if (item.id === action.payload) return { ...item, "feedback": feedback };
                return item;
            })
            if (state.chosenTopic.id === topic.id) {
                state.chosenTopic = { ...state.chosenTopic, "feedback": feedback };
            }
        }
    },
    extraReducers: {
        [fetchCurrentBot.pending]: (state) => {
            state.currentBot.status = 'loading';
        },
        [fetchCurrentBot.fulfilled]: (state, action) => {
            state.currentBot.status = 'succeeded';
            // Update state with fetched bot details, storing it by botId
            state.currentBot.data[action.payload.id] = action.payload.data;
        },
        [fetchCurrentBot.rejected]: (state, action) => {
            if (!state.currentBot) {
                state.currentBot = { data: {}, status: "", error: "" };
            }
            state.currentBot.status = 'failed';
            state.currentBot.error = action.error.message;
        },
    },
});

export const { resetState, setTopics, setChosenBot, setChosenTopic, updateCurrentBotInfo, setTopicEnded, setTopicFeedback } = chatBoxSlice.actions;
export default chatBoxSlice.reducer;
